/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JusoVo
 */
export interface JusoVo {
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    siNm?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    lnbrMnnm?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    bdKdcd?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    jibunAddr?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    buldSlno?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    bdMgtSn?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    zipNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    roadAddr?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    admCd?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    liNm?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    bdNm?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    mtYn?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    rnMgtSn?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    roadAddrPart2?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    sggNm?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    buldMnnm?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    roadAddrPart1?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    emdNm?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    lnbrSlno?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    engAddr?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    udrtYn?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    rn?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    detBdNmList?: string;
    /**
     * 
     * @type {string}
     * @memberof JusoVo
     */
    emdNo?: string;
}

/**
 * Check if a given object implements the JusoVo interface.
 */
export function instanceOfJusoVo(value: object): value is JusoVo {
    return true;
}

export function JusoVoFromJSON(json: any): JusoVo {
    return JusoVoFromJSONTyped(json, false);
}

export function JusoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JusoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'siNm': json['siNm'] == null ? undefined : json['siNm'],
        'lnbrMnnm': json['lnbrMnnm'] == null ? undefined : json['lnbrMnnm'],
        'bdKdcd': json['bdKdcd'] == null ? undefined : json['bdKdcd'],
        'jibunAddr': json['jibunAddr'] == null ? undefined : json['jibunAddr'],
        'buldSlno': json['buldSlno'] == null ? undefined : json['buldSlno'],
        'bdMgtSn': json['bdMgtSn'] == null ? undefined : json['bdMgtSn'],
        'zipNo': json['zipNo'] == null ? undefined : json['zipNo'],
        'roadAddr': json['roadAddr'] == null ? undefined : json['roadAddr'],
        'admCd': json['admCd'] == null ? undefined : json['admCd'],
        'liNm': json['liNm'] == null ? undefined : json['liNm'],
        'bdNm': json['bdNm'] == null ? undefined : json['bdNm'],
        'mtYn': json['mtYn'] == null ? undefined : json['mtYn'],
        'rnMgtSn': json['rnMgtSn'] == null ? undefined : json['rnMgtSn'],
        'roadAddrPart2': json['roadAddrPart2'] == null ? undefined : json['roadAddrPart2'],
        'sggNm': json['sggNm'] == null ? undefined : json['sggNm'],
        'buldMnnm': json['buldMnnm'] == null ? undefined : json['buldMnnm'],
        'roadAddrPart1': json['roadAddrPart1'] == null ? undefined : json['roadAddrPart1'],
        'emdNm': json['emdNm'] == null ? undefined : json['emdNm'],
        'lnbrSlno': json['lnbrSlno'] == null ? undefined : json['lnbrSlno'],
        'engAddr': json['engAddr'] == null ? undefined : json['engAddr'],
        'udrtYn': json['udrtYn'] == null ? undefined : json['udrtYn'],
        'rn': json['rn'] == null ? undefined : json['rn'],
        'detBdNmList': json['detBdNmList'] == null ? undefined : json['detBdNmList'],
        'emdNo': json['emdNo'] == null ? undefined : json['emdNo'],
    };
}

export function JusoVoToJSON(json: any): JusoVo {
    return JusoVoToJSONTyped(json, false);
}

export function JusoVoToJSONTyped(value?: JusoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'siNm': value['siNm'],
        'lnbrMnnm': value['lnbrMnnm'],
        'bdKdcd': value['bdKdcd'],
        'jibunAddr': value['jibunAddr'],
        'buldSlno': value['buldSlno'],
        'bdMgtSn': value['bdMgtSn'],
        'zipNo': value['zipNo'],
        'roadAddr': value['roadAddr'],
        'admCd': value['admCd'],
        'liNm': value['liNm'],
        'bdNm': value['bdNm'],
        'mtYn': value['mtYn'],
        'rnMgtSn': value['rnMgtSn'],
        'roadAddrPart2': value['roadAddrPart2'],
        'sggNm': value['sggNm'],
        'buldMnnm': value['buldMnnm'],
        'roadAddrPart1': value['roadAddrPart1'],
        'emdNm': value['emdNm'],
        'lnbrSlno': value['lnbrSlno'],
        'engAddr': value['engAddr'],
        'udrtYn': value['udrtYn'],
        'rn': value['rn'],
        'detBdNmList': value['detBdNmList'],
        'emdNo': value['emdNo'],
    };
}

